import React, { useState, useEffect, useRef } from "react";
import Loading from "../../Student/Reusablecomponents/Loading";
import CopyRight from "../../Student/Reusablecomponents/Copyright";
import { RiDeleteBin5Line } from "react-icons/ri";
import { FaRegSave } from "react-icons/fa";
// import { HiMiniPlusSmall } from "react-icons/hi2";
import { FaVideo } from "react-icons/fa";
import { FiDownload } from "react-icons/fi";
import { IoIosRemoveCircleOutline } from "react-icons/io";
import { TabViewValues } from "../../ReusableComponents/CommonFunctions";
import { BackNavigation } from "../../Student/Reusablecomponents/RegularFunctions";
import axios from "axios";
import { useSelector, useDispatch } from "react-redux";
import { useNavigate, useLocation } from "react-router-dom";
import { QBSubjectnames } from "../../ReusableComponents/CommonFunctions";
// import { AlertOptionsData } from "../../Redux/Reducers/Common/Alerts";
// import { Alert } from "../../Student/Reusablecomponents/RegularFunctions";
import notify from "../../ReusableComponents/ToastifyAlerts";
const Rmaterial = (props) => {
  //   const myRef = useRef(null);

  const dispatch = useDispatch();
  const location = useLocation();
  const navigate = useNavigate();

  const AudioRef = useRef(null);
  const WERef = useRef(null);
  const FCRef = useRef(null);
  const CSRef = useRef(null);

  const items = useSelector((state) => state.userDetailsData.LoginDetails);
  const FQuestionDetails = useSelector((state) => state.FQDetails.FQDetails);
  const Student = JSON.parse(localStorage.getItem("StudentRemidation"));
  const [RList, SetRList] = useState();
  const [files, setFiles] = useState();
  const [VideoUrl, SetVideoUrl] = useState();

  const [Load, SetLoad] = useState(false);
  const [SelectRoll, setSelectRoll] = useState(Student?.UserType || 12);
  const [rows, setRows] = useState({
    Video: [1],
    Audio: [1],
    WExamples: [1],
    Flashcards: [1],
    CSheets: [1],
  });

  // const addRow = (key) => {
  //   setRows((prevRows) => ({
  //     ...prevRows,
  //     [key]: [...prevRows[key], prevRows[key].length + 1],
  //   }));
  // };
  const RCategoryList = async () => {
    SetLoad((prev) => !prev);
    await axios
      .get(
        process.env.REACT_APP_API_BASE_URL +
        `/QuestionBankByLO/GetLORemediationContent?SubjectId=${items?.subjectId || Student?.SubId
        }&LoLovId=${FQuestionDetails?.loid ||
        Student?.LovId ||
        FQuestionDetails?.level3Id ||
        FQuestionDetails?.grammarId
        }
          &GradeId=${FQuestionDetails.gradeName || Student?.Grade || 0
        }&ChapterId=${FQuestionDetails.chapterName || Student?.Chapter || 0
        }&RemediationCategoryId=${SelectRoll}`,
        { headers: { XApiKey: process.env.REACT_APP_XApiKey } }
      )
      .then((res) => {
        if (res.data?.[0]?.remediationType) {
          const groupedData = res.data.reduce((acc, item) => {
            if (!acc[item.remediationType]) {
              acc[item.remediationType] = [];
            }
            acc[item.remediationType].push(item);
            return acc;
          }, {});
          SetRList(groupedData);
        } else {
          SetRList("");
        }
        SetLoad((prev) => !prev);
        clearinput();
      })
      .catch((err) => {
        console.log(err);
      });
  };
  useEffect(() => {
    RCategoryList();
  }, [SelectRoll]);

  const clearinput = () => {
    AudioRef.current.value = null;
    WERef.current.value = null;
    FCRef.current.value = null;
    CSRef.current.value = null;
  };
  console.log("files", files?.[0]?.name.split(".")[1])
  const SaveFiles = async (Rtype, key, AType) => {
    // const AddedFile = `.${files?.[0]?.name.split(".")[1]}`
   const AddedFile = `.${files?.[0]?.name.split(".").pop()}`;

    console.log(AType,"test",AddedFile)
    const urlRegex =
      /^(https?:\/\/)?([\w\-])+(\.[\w\-]+)+([\w.,@?^=%&:/~+#\-]*[\w@?^=%&/~+#\-])?$/;
    if (AType?.includes(AddedFile) || urlRegex.test(VideoUrl)) {

      if (files || urlRegex.test(VideoUrl)) {
        SetLoad((prev) => !prev);
        const formData = new FormData();
        formData.append("File", files?.[0] || "");
        formData.append("SubjectId", items.subjectId);
        formData.append("ChapterId", FQuestionDetails.chapterName || 0);
        formData.append(
          "LOLovId",
          FQuestionDetails.loid ||
          FQuestionDetails?.level3Id ||
          FQuestionDetails?.grammarId
        );
        formData.append("GradeId", FQuestionDetails.gradeName || 0);
        formData.append("VideoUrl", VideoUrl || "");
        formData.append("RemediationTypeId", Rtype);
        formData.append("RemediationCategoryId", SelectRoll);
        formData.append("CreatedBy", items?.userId);

        await axios
          .post(
            process.env.REACT_APP_API_BASE_URL +
            `/QuestionBankByLO/AddRemediatioContent`,
            formData,
            { headers: { XApiKey: process.env.REACT_APP_XApiKey } }
          )
          .then((res) => {
            setFiles("");
            SetVideoUrl("");
            RCategoryList();
            SetLoad((prev) => !prev);
            scrollToElement();
            notify("Remediation content added successfully", "success");
            // dispatch(
            //   AlertOptionsData({
            //     Status: true,
            //     color: "",
            //     Location: location?.pathname,
            //     Message: "Remediation content added successfully",
            //   })
            // );
          })
          .catch((err) => {
            console.log(err);
          });
      } else {
        notify(`${key === "Video"
          ? "Please provide valid URL"
          : "Please select file to upload"}`, "warning");

        // dispatch(
        //   AlertOptionsData({
        //     Status: true,
        //     color: "text-danger",
        //     Location: location?.pathname,
        //     Message: `${
        //       key === "Video"
        //         ? "Please provide valid URL"
        //         : "Please select file to upload"
        //     }`,
        //   })
        // );
        scrollToElement();
      }
    } else {
      notify("File format is not valid", "error");
    }
  };

  const DeleteFile = async (Fid) => {
    if (
      window.confirm(
        "Are you sure you want to delete the remediation content ?"
      )
    ) {
      SetLoad((prev) => !prev);
      await axios
        .get(
          process.env.REACT_APP_API_BASE_URL +
          `/QuestionBankByLO/DeleteRemediationContentFile?FileId=${Fid}&LoLovId=${FQuestionDetails.loid}&GradeId=${FQuestionDetails.gradeName}&ChapterId=${FQuestionDetails.chapterName}&RemediationCategoryId=${SelectRoll}`,
          { headers: { XApiKey: process.env.REACT_APP_XApiKey } }
        )
        .then((res) => {
          RCategoryList();
          notify("Remediation content deleted successfully", "success");
          // dispatch(
          //   AlertOptionsData({
          //     Status: true,
          //     color: "text-danger",
          //     Location: location?.pathname,
          //     Message: "Remediation content deleted successfully",
          //   })
          // );
          scrollToElement();
          SetLoad((prev) => !prev);
        })
        .catch((err) => {
          console.log(err);
        });
    }
  };

  const sectionsConfig = [
    {
      key: "Video",
      title: SelectRoll === 13 ? "Instruction Video" : "Video URL",
      typeId: SelectRoll === 13 ? 46 : 42,
    },
    {
      key: "Audio",
      title: SelectRoll === 13 ? "Instruction Audio" : "Audio",
      typeId: SelectRoll === 13 ? 866 : 44,
      accept: ".mp3",
      Instruction: "Only .mp3 files are allowed",
      Clear: AudioRef,
    },
    {
      key: "WExamples",
      title: SelectRoll === 13 ? "Targeted Lesson Plan" : "Worked Out Examples",
      typeId: SelectRoll === 13 ? 45 : 43,
      Clear: WERef,
      accept: ".docx, .jpg, .png, .pdf, .ppt, .xls, .doc, .xlsx, .jpeg",
      Instruction:
        "Only .docx, .jpg, .png, .pdf, .ppt, .xls, .doc, .xlsx, .jpeg files are allowed",
    },
    ...(SelectRoll === 12
      ? [
        {
          key: "Flashcards",
          title: "Flash cards",
          typeId: 41,
          accept: ".docx, .jpg, .png, .pdf, .ppt, .xls, .doc, .xlsx, .jpeg",
          Instruction:
            "Only .docx, .jpg, .png, .pdf, .ppt, .xls, .doc, .xlsx, .jpeg files are allowed",
          Clear: FCRef,
        },
        {
          key: "CSheets",
          title: "Cheat sheets",
          typeId: 40,
          accept: ".docx, .jpg, .png, .pdf, .ppt, .xls, .doc, .xlsx, .jpeg",
          Instruction:
            "Only .docx, .jpg, .png, .pdf, .ppt, .xls, .doc, .xlsx, .jpeg files are allowed",
          Clear: CSRef,
        },
      ]
      : []),
  ];
  const Downloadfile = async (File) => {
    SetLoad((prev) => !prev); // Toggle loading state
    try {
      const response = await axios.get(
        `${process.env.REACT_APP_API_BASE_URL}/QuestionBankByLO/GetFileById?FileId=${File.id}`,
        {
          headers: { XApiKey: process.env.REACT_APP_XApiKey },
          responseType: "blob", // Important for file downloads
        }
      );

      // Extract filename from response headers if available
      const contentDisposition = response.headers["content-disposition"];
      const outputFilename = File.fileNameorVideoUrl;
      // const outputFilename = contentDisposition
      // ? contentDisposition.split('filename=')[1].replace(/"/g, '') // Clean quotes, if any
      // : `${Date.now()}.xls`;

      // Create URL and initiate download
      const url = URL.createObjectURL(new Blob([response.data]));
      const link = document.createElement("a");
      link.href = url;
      link.setAttribute("download", outputFilename);
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link); // Clean up

      // Revoke the object URL after download
      URL.revokeObjectURL(url);
    } catch (error) {
      console.error("File download failed:", error);
    } finally {
      notify("Downloaded successfully", "success");

      // dispatch(
      //   AlertOptionsData({
      //     Status: true,
      //     color: "",
      //     Location: location?.pathname,
      //     Message: "Downloaded successfully",
      //   })
      // );

      SetLoad((prev) => !prev); // Toggle loading state back
    }
  };

  const renderSection = ({
    key,
    title,
    typeId,
    accept,
    Instruction,
    Clear,
  }) => (
    ((Student?.RTables?.includes(key) && items.userTypeId === 4) || items.userTypeId === 7) &&
    <div className="Card NCLDataTable" key={key} ref={myRef}>
      <div className="SubHeading">{title}</div>
      <table className="Data-Table mb-2">
        <thead>
          <tr>
            <th>S.No</th>
            <th>Files</th>
            <th>Action</th>
            {key !== "Video" && <th>Accepted formats</th>}
          </tr>
        </thead>
        <tbody>
          {RList?.[title === "Video URL" ? "Video" : title] ? (
            (RList?.[title === "Video URL" ? "Video" : title] || []).map(
              (item, index) => (
                <tr key={index}>
                  <td>{index + 1}</td>
                  <td
                    className="dflex gap-2 alignitems CPointer"
                    onClick={() => {
                      if (key === "Video") {
                        window.open(item.fileNameorVideoUrl);
                      }
                    }}
                  >
                    {" "}
                    {key === "Video" && <FaVideo />}
                    {item.fileNameorVideoUrl}
                  </td>

                  <td>
                    <div
                      className="dflex CPointer JCCenter"
                      style={{ gap: "15px"}}
                    >
                      {!Student && (
                        <RiDeleteBin5Line
                          title="Delete"
                          style={{ color: "#FD3333" }}
                          size={20}
                          onClick={() => DeleteFile(item.id)}
                        />
                      )}
                      {key !== "Video" ? (
                        <FiDownload
                          title="Download"
                          size={20}
                          onClick={() => Downloadfile(item)}
                        />
                      ) : (
                        ""
                        // <FaRegEye
                        //   title="Open Link"
                        //   onClick={() => {
                        //     window.open(item.fileNameorVideoUrl);
                        //   }}
                        // />
                      )}
                    </div>
                  </td>
                  {key !== "Video" && <td>{item.fileType}</td>}
                </tr>
              )
            )
          ) : (
            <tr>
              <td colSpan="4">**No data found**</td>
            </tr>
          )}
          {!Student &&
            rows[key]?.map((_, index) => (
              <tr key={index}>
                <td>{index + (RList?.[title]?.length || 0) + 1}</td>
                <td className="dflex">
                  {" "}
                  {key === "Video" ? (
                    <input
                      type="text"
                      className="w-50"
                      placeholder="Please Enter URL"
                      value={VideoUrl}
                      onChange={(e) => SetVideoUrl(e.target.value)}
                    />
                  ) : (
                    <input
                      type="file"
                      accept={accept}
                      ref={Clear}
                      onChange={(e) => setFiles(e.target.files)}
                    />
                  )}
                </td>
                <td>
                  <div
                    className="dflex CPointer"
                    style={{ gap: "15px", justifyContent: "center" }}
                  >
                    <FaRegSave
                      title="Save"
                      size={20}
                      onClick={() => SaveFiles(typeId, key, accept)}
                    />
                    <IoIosRemoveCircleOutline
                      size={20}
                      title="Remove"
                      style={{ color: "#FD3333" }}
                      onClick={() => {
                        if (key === "Video") {
                          SetVideoUrl("");
                        } else {
                          Clear.current.value = "";
                        }
                        setFiles("");
                      }}
                    />
                  </div>
                </td>
                {key !== "Video" && <td>{Instruction}</td>}
              </tr>
            ))}
        </tbody>
      </table>
    </div>

  );
  const myRef = useRef(null);

  const scrollToElement = () => {
    myRef.current.scrollIntoView({ behavior: "smooth" });
  };
  // items.subjectId !==3 &&
  return (
    <div ref={myRef} className={Student && "TeacherBgImage"}>
      {/* {(!Student && items.subjectId !== "3") && (
        <div className="dflex alignitems">

          {items.subjectName} &gt;{" "}
          {items.subjectId == "3" ? (
            <>
              {" "}
              {FQuestionDetails?.characteristicsName}{" "}
              {!FQuestionDetails?.grammarName && "> "}{" "}
              {FQuestionDetails?.level1Name}{" "}
              {!FQuestionDetails?.grammarName && "> "}{" "}
              {FQuestionDetails?.level2Name}{" "}
              {!FQuestionDetails?.grammarName && "> "}{" "}
              <b className="text-success">
                {FQuestionDetails?.level3Name || FQuestionDetails?.grammarName}
              </b>{" "}
            </>
          ) : (
            <>
              {" "}
              {FQuestionDetails.topicName} &gt; {FQuestionDetails.subTopicName}{" "}
              &gt; <b className="text-success"> {FQuestionDetails.loName}</b>
            </>
          )}
        </div>
      )} */}

      {/* {Student && <Alert />} */}
      {/* <div className="dflex JSBetween mt-3"> */}
      {/* <BackNavigation
          Navigation={() => {
            !props.Back ? navigate(-1) : props.Back(false);
          }}
        /> */}
      <div className="MainHeading">Remediation Content</div>
      {/* <div></div> */}
      {/* </div> */}

      <div className="dflex gap-3 mt-2">
        <div>
          <b>Subject :</b> {Student?.SubjectName || items.subjectName}
        </div>
        {items.subjectId === "3" ? (
          <>
            <div>
              {" "}
              <b>Characteristics :</b> {FQuestionDetails.characteristicsName}{" "}
            </div>
            <div>
              {" "}
              <b>Level 1 : </b> {FQuestionDetails.level1Name}{" "}
            </div>
            <div>
              {" "}
              <b>Level 2 : </b> {FQuestionDetails.level2Name}{" "}
            </div>
            <div>
              {" "}
              <b>Level 3 : </b> {FQuestionDetails.level2Name}{" "}
            </div>
          </>
        ) : (
          <>
            {!Student && (
              <div>
                {" "}
                <b>Topic :</b> {FQuestionDetails.topicName}{" "}
              </div>
            )}
            <div>
              {" "}
              <b>Chapter :</b>{" "}
              {Student?.Chapter || FQuestionDetails.chapterName}{" "}
            </div>
            <div>
              {" "}
              <b>Grade : </b> {Student?.Grade || FQuestionDetails.gradeName}{" "}
            </div>
            <div>
              {" "}
              <b>Learning Outcome : </b>{" "}
              {Student?.loName || FQuestionDetails.loName}{" "}
            </div>
          </>
        )}
      </div>
      {!Student && (
        <TabViewValues
          Tabs={[
            { Name: "Student", Value: 12 },
            { Name: "Teacher", Value: 13 },
          ]}
          Selectedtab={SelectRoll}
          onClick={(e) => setSelectRoll(e)}
        />
      )}
      <div className="dflex gap-3 flexd-column mt-2">
        {sectionsConfig.map(renderSection)}
      </div>
      {Student && <CopyRight />}
      {Load && <Loading />}
    </div>
  );
};
export default Rmaterial;
